import React from 'react';
import { Container, Switch, Typography } from '@mui/material';

import { StyledLink } from '../../components/modules/connections/Styles';

interface ItemWithSwitchProps {
    readonly header: string;
    readonly description: string;
    readonly labelSwitch: string;
    readonly width?: string;
    readonly link?: string;
    readonly linkDescription?: string;
}

const colorTypographyGray = 'rgba(0, 0, 0, 0.60)';

function ItemWithSwitch({
    header,
    description,
    labelSwitch,
    width,
    link,
    linkDescription,
}: ItemWithSwitchProps) {
    return (
        <Container
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0px',

                paddingLeft: '0px !important',
            }}
        >
            <Container
                sx={{
                    display: 'flex',
                    gap: '96px',
                    alignItems: 'center',
                    paddingLeft: '0px !important',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '24px',
                        width: width || '696px',
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{ color: colorTypographyGray }}
                    >
                        {header}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{ color: colorTypographyGray }}
                    >
                        {description}
                    </Typography>
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '24px',
                    }}
                >
                    <Switch color={'primary'} />
                    <Typography
                        variant="body1"
                        sx={{ color: 'rgba(0, 0, 0, 0.87)' }}
                    >
                        {labelSwitch}
                    </Typography>
                </div>
            </Container>
            {link && linkDescription && (
                <StyledLink color="primary" target="_blank" to={link}>
                    {linkDescription}
                </StyledLink>
            )}
        </Container>
    );
}

export default ItemWithSwitch;
